const campusAreas = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.141488, 49.90055, 0],
            [-97.141884, 49.900011, 0],
            [-97.141766, 49.899978, 0],
            [-97.141848, 49.899876, 0],
            [-97.141541, 49.899783, 0],
            [-97.141271, 49.900159, 0],
            [-97.141188, 49.900134, 0],
            [-97.140957, 49.900449, 0],
            [-97.141329, 49.900562, 0],
            [-97.141361, 49.900513, 0],
            [-97.141488, 49.90055, 0],
          ],
        ],
      },
      properties: {
        name: 'Roblin Centre Building P',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.142068, 49.900322, 0],
            [-97.142316, 49.899985, 0],
            [-97.141974, 49.899883, 0],
            [-97.14173, 49.90022, 0],
            [-97.142068, 49.900322, 0],
          ],
        ],
      },
      properties: {
        name: 'Roblin Centre Building W',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.141774, 49.900722, 0],
            [-97.141974, 49.900444, 0],
            [-97.14163, 49.900342, 0],
            [-97.141433, 49.90062, 0],
            [-97.141774, 49.900722, 0],
          ],
        ],
      },
      properties: {
        name: 'Roblin Centre Building A',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.142184, 49.901367, 0],
            [-97.142409, 49.901094, 0],
            [-97.141396, 49.900782, 0],
            [-97.141187, 49.901063, 0],
            [-97.142184, 49.901367, 0],
          ],
        ],
      },
      properties: {
        name: 'Manitou a bi Bii daziigae',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.140162, 49.899106, 0],
            [-97.140167, 49.8989, 0],
            [-97.140132, 49.898892, 0],
            [-97.140132, 49.898864, 0],
            [-97.140155, 49.898868, 0],
            [-97.140153, 49.89876, 0],
            [-97.139478, 49.898614, 0],
            [-97.139245, 49.898879, 0],
            [-97.140162, 49.899106, 0],
          ],
        ],
      },
      properties: {
        name: 'Paterson GlobalFoods Institute',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.141965, 49.900592, 0],
            [-97.141863, 49.900557, 0],
            [-97.141627, 49.900882, 0],
            [-97.141718, 49.90091, 0],
            [-97.141965, 49.900592, 0],
          ],
        ],
      },
      properties: {
        name: 'Skywalk',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.212225, 49.918335, 0],
            [-97.212225, 49.918086, 0],
            [-97.211817, 49.918086, 0],
            [-97.211817, 49.918335, 0],
            [-97.212225, 49.918335, 0],
          ],
        ],
      },
      properties: {
        name: 'Building C',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.213338, 49.917985, 0],
            [-97.213338, 49.917762, 0],
            [-97.212325, 49.917762, 0],
            [-97.212325, 49.917985, 0],
            [-97.213338, 49.917985, 0],
          ],
        ],
      },
      properties: {
        name: 'Building D',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.213338, 49.91882, 0],
            [-97.213338, 49.91861, 0],
            [-97.212325, 49.91861, 0],
            [-97.212325, 49.91882, 0],
            [-97.213338, 49.91882, 0],
          ],
        ],
      },
      properties: {
        name: 'Building F',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21362, 49.91866, 0],
            [-97.21362, 49.91794, 0],
            [-97.21321, 49.91794, 0],
            [-97.21321, 49.91866, 0],
            [-97.21362, 49.91866, 0],
          ],
        ],
      },
      properties: {
        name: 'Building E',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21324, 49.920277, 0],
            [-97.21324, 49.920027, 0],
            [-97.212814, 49.920027, 0],
            [-97.212814, 49.920277, 0],
            [-97.21324, 49.920277, 0],
          ],
        ],
      },
      properties: {
        name: 'Greenhouse',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21236, 49.91936, 0],
            [-97.21236, 49.91893, 0],
            [-97.21221, 49.91893, 0],
            [-97.21221, 49.91881, 0],
            [-97.21182, 49.91881, 0],
            [-97.21182, 49.91893, 0],
            [-97.21167, 49.91893, 0],
            [-97.21167, 49.91936, 0],
            [-97.21236, 49.91936, 0],
          ],
        ],
      },
      properties: {
        name: 'North Gym',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21167, 49.91931, 0],
            [-97.21167, 49.9192, 0],
            [-97.21157, 49.9192, 0],
            [-97.21157, 49.91924, 0],
            [-97.21147, 49.91924, 0],
            [-97.21147, 49.9192, 0],
            [-97.21119, 49.9192, 0],
            [-97.21119, 49.91937, 0],
            [-97.21157, 49.91937, 0],
            [-97.21157, 49.91931, 0],
            [-97.21167, 49.91931, 0],
          ],
        ],
      },
      properties: {
        name: 'Building H',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21061, 49.9202, 0],
            [-97.21061, 49.91954, 0],
            [-97.21056, 49.91954, 0],
            [-97.21056, 49.91935, 0],
            [-97.21045, 49.91929, 0],
            [-97.21045, 49.9192, 0],
            [-97.2104, 49.9192, 0],
            [-97.2104, 49.91871, 0],
            [-97.21035, 49.91871, 0],
            [-97.21035, 49.9192, 0],
            [-97.20988, 49.9192, 0],
            [-97.20988, 49.91946, 0],
            [-97.20973, 49.91946, 0],
            [-97.20973, 49.9196, 0],
            [-97.21002, 49.9196, 0],
            [-97.21002, 49.9202, 0],
            [-97.21061, 49.9202, 0],
          ],
        ],
      },
      properties: {
        name: 'Building J',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20951, 49.92046, 0],
            [-97.20951, 49.91965, 0],
            [-97.21002, 49.91965, 0],
            [-97.21002, 49.91961, 0],
            [-97.20951, 49.91961, 0],
            [-97.20951, 49.91929, 0],
            [-97.20927, 49.91929, 0],
            [-97.20927, 49.91922, 0],
            [-97.20918, 49.91922, 0],
            [-97.20918, 49.91929, 0],
            [-97.20909, 49.91929, 0],
            [-97.20909, 49.92046, 0],
            [-97.20951, 49.92046, 0],
          ],
        ],
      },
      properties: {
        name: 'Building M',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20876, 49.92034, 0],
            [-97.20876, 49.92016, 0],
            [-97.20861, 49.92016, 0],
            [-97.20861, 49.91966, 0],
            [-97.20909, 49.91966, 0],
            [-97.20909, 49.91962, 0],
            [-97.20876, 49.91962, 0],
            [-97.20876, 49.91955, 0],
            [-97.20776, 49.91955, 0],
            [-97.20776, 49.91966, 0],
            [-97.20803, 49.91966, 0],
            [-97.20803, 49.92034, 0],
            [-97.20876, 49.92034, 0],
          ],
        ],
      },
      properties: {
        name: 'Building Z',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21008, 49.91833, 0],
            [-97.21008, 49.9181, 0],
            [-97.2096, 49.9181, 0],
            [-97.2096, 49.91833, 0],
            [-97.21008, 49.91833, 0],
          ],
        ],
      },
      properties: {
        name: 'Building P',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.2106, 49.91773, 0],
            [-97.2106, 49.91741, 0],
            [-97.21012, 49.91741, 0],
            [-97.21012, 49.91773, 0],
            [-97.2106, 49.91773, 0],
          ],
        ],
      },
      properties: {
        name: 'South Gym',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21153, 49.91812, 0],
            [-97.21153, 49.91783, 0],
            [-97.21056, 49.91783, 0],
            [-97.21056, 49.91773, 0],
            [-97.21034, 49.91773, 0],
            [-97.21034, 49.91783, 0],
            [-97.21023, 49.91783, 0],
            [-97.21023, 49.91812, 0],
            [-97.21153, 49.91812, 0],
          ],
        ],
      },
      properties: {
        name: 'Building A',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.21176, 49.91887, 0],
            [-97.21176, 49.9185, 0],
            [-97.21142, 49.9185, 0],
            [-97.21142, 49.91812, 0],
            [-97.21097, 49.91812, 0],
            [-97.21097, 49.91824, 0],
            [-97.21059, 49.91824, 0],
            [-97.21059, 49.91812, 0],
            [-97.21034, 49.91812, 0],
            [-97.21034, 49.91838, 0],
            [-97.20903, 49.91838, 0],
            [-97.20903, 49.91817, 0],
            [-97.20839, 49.91817, 0],
            [-97.20839, 49.91875, 0],
            [-97.20904, 49.91875, 0],
            [-97.20904, 49.91871, 0],
            [-97.20939, 49.91871, 0],
            [-97.20939, 49.91875, 0],
            [-97.20953, 49.91875, 0],
            [-97.20953, 49.91895, 0],
            [-97.21021, 49.91895, 0],
            [-97.21021, 49.91875, 0],
            [-97.21035, 49.91875, 0],
            [-97.21035, 49.91871, 0],
            [-97.21077, 49.91871, 0],
            [-97.21077, 49.91875, 0],
            [-97.21133, 49.91875, 0],
            [-97.21152, 49.91887, 0],
            [-97.21176, 49.91887, 0],
          ],
        ],
      },
      properties: {
        name: 'Building B',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20939, 49.91838, 0],
            [-97.20939, 49.91817, 0],
            [-97.20943, 49.91817, 0],
            [-97.20943, 49.91812, 0],
            [-97.2095, 49.91812, 0],
            [-97.2095, 49.91786, 0],
            [-97.2073, 49.91786, 0],
            [-97.2073, 49.918, 0],
            [-97.20717, 49.918, 0],
            [-97.20717, 49.91822, 0],
            [-97.20839, 49.91822, 0],
            [-97.20839, 49.91817, 0],
            [-97.20903, 49.91817, 0],
            [-97.20903, 49.91838, 0],
            [-97.20939, 49.91838, 0],
          ],
        ],
      },
      properties: {
        name: 'Building T',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.212225, 49.91781, 0],
            [-97.212225, 49.91774, 0],
            [-97.211817, 49.91774, 0],
            [-97.211817, 49.91781, 0],
            [-97.212225, 49.91781, 0],
          ],
        ],
      },
      properties: {
        name: 'Front Entrance',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.20733, 49.91852, 0],
            [-97.20733, 49.91831, 0],
            [-97.20717, 49.91831, 0],
            [-97.20717, 49.91852, 0],
            [-97.20733, 49.91852, 0],
          ],
        ],
      },
      properties: {
        name: 'V',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: [
          [
            [-97.25184, 49.90431, 0],
            [-97.25176, 49.90383, 0],
            [-97.251529, 49.903849, 0],
            [-97.251547, 49.90395, 0],
            [-97.25036, 49.90403, 0],
            [-97.25043, 49.90432, 0],
            [-97.25119, 49.90426, 0],
            [-97.251215, 49.90436, 0],
            [-97.25184, 49.90431, 0],
          ],
        ],
      },
      properties: {
        name: 'Stevenson (Airport)',
        styleUrl: '#poly-A5ACB1-1000-255-nodesc',
        styleHash: '33ab695b',
        styleMapHash: {
          normal: '#poly-A5ACB1-1000-255-nodesc-normal',
          highlight: '#poly-A5ACB1-1000-255-nodesc-highlight',
        },
        stroke: '#a5acb1',
        'stroke-opacity': 1,
        'stroke-width': 1,
        fill: '#a5acb1',
        'fill-opacity': 1,
      },
    },
  ],
};

export default campusAreas;
